import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../api/axios";
import toast from "../../../shared/toast";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import Loading from "../../../shared/Loading";
import WaitLoading from "../../../shared/WaitLoading";

export default function CompanyDetail() {
  const navigate = useNavigate();
  const params = useParams();

  const [formData, setFormData] = useState({
    companyName: "",
    companyLocation: "",
    tags: [],
  });
  const [loading, setLoading] = useState(false);
  const [sendingLoading, setSendingLoading] = useState(false);

  const { companyName, tags, companyLocation } = formData;

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`/api-admin/companies/${params.companyId}`)
      .then((response) => {
        const clientData = response.data.result;
        setFormData({
          companyName: clientData.name || "",
          tags: clientData.companyLocation || [],
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast("error", error.response.data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSendingLoading(true);

    const userData = {
      name: companyName,
      tags,
    };
    try {
      const response = await axiosInstance.post(
        `/api-admin/companies/edit-company/${params.companyId}`,
        userData
      );
      toast("success", response.data.message);
      navigate("/companies");

      setFormData({
        companyName: "",
        companyLocation: "",
        tags: [],
      });
    } catch (error) {
      console.error("Error posting data:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast("error", error.response.data.message);
      } else {
        toast("error", "Szerver hiba");
      }
    } finally {
      setSendingLoading(false);
    }
  };

  const handleTagAddWithButton = () => {
    if (companyLocation.trim() !== "") {
      const newTag = {
        id: new Date().getTime(),
        location: companyLocation,
      };
      setFormData((prevState) => ({
        ...prevState,
        tags: [...prevState.tags, newTag],
        companyLocation: "",
      }));
    }
  };

  const handleTagDelete = (tagId) => {
    setFormData((prevState) => ({
      ...prevState,
      tags: prevState.tags.filter((tag) => tag.id !== tagId),
    }));
  };

  if (sendingLoading) {
    return <WaitLoading />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header card-no-border pb-3">
              <h3>Cég szerkesztése</h3>
            </div>
            {!loading ? (
              <div className="card-body">
                <div className="horizontal-wizard-wrapper">
                  <div className="row g-3">
                    <div className="col-12">
                      <div
                        className="tab-content dark-field"
                        id="horizontal-wizard-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="wizard-info"
                          role="tabpanel"
                          aria-labelledby="wizard-info-tab"
                        >
                          <form
                            className="row g-3 needs-validation basic-form"
                            onSubmit={onSubmit}
                          >
                            <div className="col-xl-4 col-sm-6">
                              <label
                                className="form-label"
                                htmlFor="companyName"
                              >
                                Cég<span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="companyName"
                                type="text"
                                placeholder="Cég név megadása"
                                required=""
                                name="companyName"
                                onChange={onChange}
                                value={companyName}
                              />
                            </div>
                            <div className="row pt-3">
                              <div className="col-xl-4 col-sm-6">
                                <label
                                  className="form-label"
                                  htmlFor="location"
                                >
                                  Telephely hozzáadása
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="">
                                  <input
                                    className="form-control"
                                    id="location"
                                    type="text"
                                    placeholder="Telephely név"
                                    name="companyLocation"
                                    onChange={onChange}
                                    value={companyLocation}
                                  />
                                  <div className="tag-container mt-2 pt-2">
                                    {tags?.map((tag) => (
                                      <span className="d-flex" key={tag.id}>
                                        <span className="badge companyLocText text-dark">
                                          {tag.location}
                                          <MdDelete
                                            style={{
                                              cursor: "pointer",
                                              color: "red",
                                              marginLeft: "5px",
                                              marginTop: "-5px",
                                            }}
                                            onClick={() =>
                                              handleTagDelete(tag.id)
                                            }
                                          />
                                        </span>
                                      </span>
                                    ))}
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-outline-success mt-3"
                                    onClick={handleTagAddWithButton}
                                  >
                                    Telephely hozzáadása
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 text-end">
                              <button
                                className="btn btn-primary"
                                disabled={sendingLoading}
                              >
                                Mentés
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
